module.exports = __webpack_public_path__ + "img/c7a888ef1b4daeca68627d9e8e9650ad.46cc687d.png";